<template>
  <div v-if="!editMode && hasAddress" class="shipping-block-list-item active">
    <address-card-information :address="addressData" />
    <i class="material-icons base-icon action-icon" @click.stop="handleClickToEditButton(true)">edit</i>
  </div>
  <div v-else class="shipping-block-edit-form">
    <address-form
      @updated="setAddress"
      :stored-address="addressData"
      :class="{'has-error': hasError}"
    />
    <mini-button-full @click.native="handleClickToConfirmButton">
      {{ $t('Confirm') }}
    </mini-button-full>
  </div>
</template>

<script async>
import { mapActions } from 'vuex';

const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');
const AddressForm = () => import(/* webpackChunkName: "vsf-address-form" */ 'theme/components/core/blocks/Form/Customer/Shipping/AddressForm.vue');
const AddressCardInformation = () => import(/* webpackChunkName: "vsf-address-card-information" */ 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList/AddressCardInformation.vue');

export default {
  name: 'GuestAddressCard',
  components: {
    AddressCardInformation,
    AddressForm,
    MiniButtonFull
  },
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  data (vm) {
    return {
      editMode: false,
      hasError: false,
      addressData: vm.address
    }
  },
  computed: {
    hasAddress () {
      return this.addressData && Object.keys(this.addressData).length;
    }
  },
  mounted () {
    this.handleClickToEditButton(!this.hasAddress);
  },
  methods: {
    ...mapActions({
      updateGuestAddress: 'address/updateGuestAddress',
      updateShippingDetailsState: 'shipping/updateShippingDetailsState'
    }),
    handleSetAddressFieldErrorState(state) {
      this.hasError = state;
    },
    setAddress(address) {
      this.addressData = address;
    },
    async handleClickToConfirmButton() {
      await this.updateGuestAddress(this.addressData)
        .then(res => {
          this.$bus.$emit('set-guest-address-as-shipping-address', res);
          this.$store.dispatch('cart/load')
          this.handleClickToEditButton(false);
          this.hasError = false;
        })
        .catch(() => {
          this.hasError = true;
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Address is not valid!'),
            action1: { label: this.$t('OK') }
          })
        });
    },
    async handleClickToEditButton (state) {
      this.editMode = state;
      await this.updateShippingDetailsState({
        shipToMyAddress: false,
        showNewAddressForm: state
      });
    }
  },
  beforeMount () {
    this.$bus.$on('set-has-error-on-address-field', this.handleSetAddressFieldErrorState);
  },
  beforeDestroy () {
    this.$bus.$off('set-has-error-on-address-field', this.handleSetAddressFieldErrorState);
  }
}
</script>

<style lang="scss" scoped>
.shipping-block-list-item {
  text-align: left;
  max-width: calc(50% - 8px);
  flex: 1 1 calc(50% - 16px);

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;

  border: 1px solid #ebebeb;
  border-radius: 5px;

  @media only screen and (max-width: 991px) {
    flex: 1 1 100%;
    max-width: none;
  }

  &.active {
    border-color: #11bb2e;

    & .shipping-block-list-item-actions {
      justify-content: space-between;
    }

    & .shipping-block-list-item-actions-link:first-child:before {
      display: none;
    }
  }

  &-actions {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    min-height: 35px;

    &-link {
      cursor: pointer;
      margin-bottom: 8px;

      color: #11bb2e;
      font-size: 12px;

      &:first-child {
        position: relative;
        padding-left: 15px;
        padding-right: 14px;

        &:before {
          width: 1px;
          height: 13px;

          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;

          margin: auto;
          content: '';

          background: #ebebeb;
        }
      }

      &:last-child {
        padding-left: 14px;
      }

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &-text {
      padding: 8px 16px;

      color: #fff;
      font-size: 12px;
      font-weight: 600;

      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;

      background-color: #11bb2e;
    }
  }

  .action-icon {
    position: absolute;
    top: 10px;
    right: 10px;

    margin: auto;
    cursor: pointer;
  }
}

.shipping-block-edit-form {
  width: 100%;
}
</style>

<style lang="scss">
.shipping-block-edit-form {
  .shipping-block {
    margin: 0 -8px;

    &.has-error {
      .address-autocomplete-input__root {
        >.address-autocomplete-container {
          &:not(:has(.input-field)) {
            .address-autocomplete__input-field {
              input {
                border: 1px solid red;
              }
            }
          }
        }

        .error-block {
          display: block;
        }
      }
    }
  }
}
</style>
